import axios from "axios";
import { Dispatch } from "redux";
import {
  GET_FAQ_SUCCESS,
  GET_FAQ_FAILURE,
  RESET_FAQ,
  FaqActionTypes,
} from "../types/faqTypes";

const API = axios.create({ baseURL: process.env.REACT_APP_API_URL });

API.defaults.withCredentials = true;

export const getFaq =
  (data: any) => async (dispatch: Dispatch<FaqActionTypes>) => {
    try {
      const response = await API.get("/faqs", {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        params: data,
      });
      if (response.status) {
        dispatch({ type: GET_FAQ_SUCCESS, payload: response.data });
      } else {
        dispatch({ type: GET_FAQ_FAILURE, payload: response.data.message });
      }
    } catch (error: any) {
      dispatch({
        type: GET_FAQ_FAILURE,
        payload: error?.response?.data?.message,
      });
    }
  };

export const resetFaq = () => (dispatch: Dispatch<FaqActionTypes>) => {
  dispatch({ type: RESET_FAQ });
};
